module.exports = __webpack_public_path__ + "img/pwa-android-1.5f2ce299.png";